export default __webpack_public_path__ + "assets/images/ef3b5b280f13e2adf80d9be30bbecff0.png";